(function () {
    'use strict';
    angular
        .module('nasracApp')
        .controller('ChangeManagementHoursMainController', ChangeManagementHoursMainController);
    ChangeManagementHoursMainController.$inject = ['$scope', '$state', 'NasracCustomerReport', 'ChangeManagementHoursReport', '$q', 'DTColumnBuilder', 'DTOptionsBuilder', 'GUIUtils', '$filter', '$compile', 'ProfileService', 'Principal'];

    function ChangeManagementHoursMainController($scope, $state, NasracCustomerReport, ChangeManagementHoursReport, $q, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $filter, $compile, ProfileService, Principal) {
        var vm = this;
        vm.nasracCustomerReports = [];
        vm.reportsFlag = false;
        vm.caseIdFlag = false;
        $scope.reportData = [];
        $scope.searchQuery = null;
        $scope.dtInstance = {};
        $scope.caseId = "NONE";
        $scope.selectedCustomer = {};
        $scope.selectedCustomer.customerName = "ALL";
        $scope.selectedClliCode = {};
        $scope.selectedClliCode.clliCode = "ALL";
        $scope.option = "NONE";
        $scope.isAdmin = true;
        $scope.fileName == "NAS_RAC Change Management Hours Report"
        $scope.clliCode = "ALL";
        checkRole();

        function checkRole() {
            var defer = $q.defer()
            var adminAuthorities = ['Administrators'];
            Principal.hasAuthority(Principal.findHasAnyAuthority(adminAuthorities)).then(function (result) {
                $scope.isAdmin = result;
                if ($scope.isAdmin)
                    $scope.clliCode = "ALL";
                else {
                    ChangeManagementHoursReport.getCurrentUser(function (result) {
                        $scope.clliCode = result.siteId;
                    });
                }
            });
        }

        $scope.tabData = [{
            heading: 'Change Management Hours Reports',
            route: 'change-management-hours',
            class: 'btn-lg'
        }];
        ChangeManagementHoursReport.getReportYears(function (result) {
            $scope.reportYear = result;
            var index = result.length - 1;
            $scope.selectedYear = result[0];
            $scope.fileName = "NAS_RAC " + $scope.selectedYear.range + " Change Management Hours Report "
            $scope.onYearChange();
        });

        $scope.onYearChange = function () {
            $scope.fileName = "NAS_RAC " + $scope.selectedYear.range + " Change Management Hours Report "
            if ($scope.isAdmin) {
                ChangeManagementHoursReport.getCustomerList({
                    year: $scope.selectedYear.reportYear
                }, function (result) {
                    $scope.customerList = result;
                    $scope.selectedCustomer.customerName = "";
                });
            }
        };
        $scope.onCustomerChange = function () {
            $scope.option = "NONE";
            $scope.clliCode = "ALL";
            $scope.clliCodeList = [];
            $scope.selectedClliCode = {};
            if ($scope.selectedCustomer != null) {
                $scope.fileName = $scope.fileName + $scope.selectedCustomer.customerName;
                ChangeManagementHoursReport.getClliCodeList({
                    year: $scope.selectedYear.reportYear,
                    customerName: $scope.selectedCustomer.customerName
                }, function (result) {
                    $scope.clliCodeList = result;

                });
            }
        };
        $scope.onClliCodeChange = function () {
            if ($scope.selectedClliCode != null) {
                $scope.option = "CLLICODE";
                $scope.clliCode = $scope.selectedClliCode.clliCode;
            }
            else {
                $scope.clliCode = "ALL";
                $scope.option = "NONE";
            }
        };
        $scope.loadDataHoursReport = function () {
            $scope.reportData = [];
            if (vm.reportsFlag || vm.caseIdFlag) {
                vm.reportsFlag = false;
                vm.caseIdFlag = false;
                $scope.option = "NONE";
                $scope.fileName = "NAS_RAC " + $scope.selectedYear + " Change Management Hours Report "
                if (!$scope.selectedCustomer || !$scope.selectedCustomer.customerName) {
                    $scope.selectedCustomer = {};
                    $scope.option = "ALL";
                    $scope.selectedCustomer.customerName = "ALL";
                    $scope.caseId = "ALL";
                    $scope.clliCode = "ALL";
                }
                ChangeManagementHoursReport.loadDataHoursReport({
                    year: $scope.selectedYear.reportYear,
                    option: $scope.option,
                    customerName: $scope.selectedCustomer.customerName,
                    caseId: $scope.caseId,
                    clliCode: $scope.clliCode
                }).$promise;
            }
            else {
                if (!$scope.selectedCustomer || !$scope.selectedCustomer.customerName) {
                    $scope.selectedCustomer = {};
                    $scope.option = "ALL";
                    $scope.selectedCustomer.customerName = "ALL";
                    $scope.caseId = "ALL";
                    $scope.clliCode = "ALL";
                }//var defer=$q.defer();
                ChangeManagementHoursReport.loadDataHoursReport({
                    year: $scope.selectedYear.reportYear,
                    option: $scope.option,
                    customerName: $scope.selectedCustomer.customerName,
                    caseId: $scope.caseId,
                    clliCode: $scope.clliCode

                }, function (result) {
                    $scope.reportData = result;
                    $scope.currentTime = new Date(new Date().getTime()).toLocaleTimeString() + ' ' + moment.tz(moment.tz.guess()).zoneAbbr();//getting current time
                    $scope.getTotal($scope.reportData);
                })
                // defer.resolve;
                $scope.dtColumns = [
                    DTColumnBuilder.newColumn('range').withTitle('Year'),
                    DTColumnBuilder.newColumn('customer').withTitle('Customer').withOption('visible', $scope.isAdmin),
                    DTColumnBuilder.newColumn('caseId').withTitle('CaseId').withOption('width', '20%').notVisible(),
                    DTColumnBuilder.newColumn('clliCode').withTitle('Site Id').withOption('width', '10%').renderWith(function (data, type, full) {
                        data = '<a ng-click="vm.query_by_year(\'' + data + '\', false);"> ' + data + '</a>'
                        return data;
                    }),
                    DTColumnBuilder.newColumn('site').withTitle('Site Name'),
                    DTColumnBuilder.newColumn('caseSummary').withTitle('CaseSummary').notVisible(),
                    DTColumnBuilder.newColumn('caseOwner').withTitle('CaseOwner').notVisible(),
                    DTColumnBuilder.newColumn('caseCreatedTime').withTitle('CaseCreatedTime').notVisible(),
                    DTColumnBuilder.newColumn('caseStatus').withTitle('CaseStatus').notVisible(),
                    DTColumnBuilder.newColumn('timeLog').withTitle('TimeLog').notVisible(),
                    DTColumnBuilder.newColumn('timeLogCreatedTime').withTitle('TimeLogCreatedTime').notVisible(),
                    DTColumnBuilder.newColumn('totalTimeHrs').withTitle('Total Time[Hrs]')
                ];
            }
        };
        $scope.getTotal = function (result) {
            $scope.total = 0.0000;

            angular.forEach(result, function (item, index) {
                $scope.total = $scope.total + item.totalTimeHrs;
            });
        };
        $scope.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                ChangeManagementHoursReport.loadDataHoursReport({
                    year: $scope.selectedYear.reportYear,
                    option: $scope.option,
                    customerName: $scope.selectedCustomer.customerName,
                    caseId: $scope.caseId,
                    clliCode: $scope.clliCode

                }, function (result) {
                    $scope.reportData = result;
                    if ($scope.clliCode != 'ALL') {
                        $scope.siteName = $scope.reportData[0].site;
                    }
                    $scope.getTotal($scope.reportData);
                    defer.resolve(result);
                });
            } else {
                defer.resolve($filter($scope.reportData, $scope.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers').withOption('createdRow', createdRow)

            .withDisplayLength(25)
            .withOption('order', [2, 'asc'])
            .withOption("lengthMenu", [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]])
            .withButtons(
                [{
                    extend: 'excel',
                    text: 'Export',
                    title: function () {
                        return getFileName();
                    },//'NAS_RAC 2017 Change Management hours Report',
                    exportOptions: {columns: ':visible'},
                    titleAttr: 'Excel'
                }])
            .withBootstrap().withDOM('tip')/*.withOption('scrollX', '100%')*/
            .withOption('fnRowCallback', function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                $compile(nRow)($scope);
            })
            .withDOM(
                "<'row'<'col-sm-3'l><'col-sm-6 text-center'B><'col-sm-3'f>>" +
                "<'row'<'col-sm-12'tr>>" +
                "<'row'<'col-sm-5'i><'col-sm-7'p>>");
        $scope.dtColumns = [
            DTColumnBuilder.newColumn('range').withTitle('Year').withOption('width', '10%'),
            DTColumnBuilder.newColumn('customer').withTitle('Customer').withOption('visible', $scope.isAdmin).withOption('width', '10%'),
            DTColumnBuilder.newColumn('clliCode').withTitle('Site Id').withOption('width', '10%').renderWith(function (data, type, full, meta) {
                data = '<a ng-click="vm.query_by_year(\'' + data + '\', false);"> ' + data + '</a>'
                return data;
            }),
            DTColumnBuilder.newColumn('caseId').withTitle('CaseId').withOption('width', '10%').notVisible(),
            DTColumnBuilder.newColumn('site').withTitle('Site Name'),
            DTColumnBuilder.newColumn('caseSummary').withTitle('CaseSummary').withOption('width', '20%').notVisible(),
            DTColumnBuilder.newColumn('caseOwner').withTitle('CaseOwner').notVisible(),
            DTColumnBuilder.newColumn('caseCreatedTime').withTitle('CaseCreatedTime').notVisible(),
            DTColumnBuilder.newColumn('caseStatus').withTitle('CaseStatus').notVisible(),
            DTColumnBuilder.newColumn('timeLog').withTitle('TimeLog').notVisible(),
            DTColumnBuilder.newColumn('timeLogCreatedTime').withTitle('TimeLogCreatedTime').notVisible(),
            DTColumnBuilder.newColumn('totalTimeHrs').withTitle('Total Time[Hrs]')
        ];
        vm.query_by_year = function (siteId) {
            $scope.fileName = "NAS_RAC " + $scope.selectedYear.range + " Change Management Hours Report "
            $scope.fileName = $scope.fileName + siteId;
            vm.caseIdFlag = false;
            vm.customer = $scope.selectedCustomer.customerName;
            vm.clliCode = siteId;
            $scope.option = 'first';
            //$scope.selectedCustomer.customerName = customer;
            var currentYear = $scope.selectedYear.reportYear;
            vm.reportsFlag = true;
            $scope.clliCode = siteId;
            ChangeManagementHoursReport.loadDataHoursReport({
                year: currentYear,
                option: 'first',
                customerName: vm.customer,
                caseId: $scope.caseId,
                siteId: vm.clliCode,
                clliCode: $scope.clliCode
            }).$promise;
            // Also change Columns visibility to display details.
            $scope.dtColumns = [
                DTColumnBuilder.newColumn('range').withTitle('Year').withOption('width', '10%'),
                DTColumnBuilder.newColumn('customer').withTitle('Customer').withOption('visible', $scope.isAdmin).withOption('width', '20%'),
                DTColumnBuilder.newColumn('clliCode').withTitle('Site Id').withOption('width', '7%'),
                DTColumnBuilder.newColumn('site').withTitle('Site Name').withOption('width', '20%'),
                DTColumnBuilder.newColumn('caseId').withTitle('Case Id').withOption('width', '7%').renderWith(function (data, type, full) {
                    if ($scope.isAdmin) {
                        data = '<a ng-click="vm.query_by_caseId(\'' + data + '\', false);"> ' + data + '</a>'
                        return data;
                    }
                    else return data;
                }),
                DTColumnBuilder.newColumn('caseSummary').withTitle('Case Summary').withOption('width', '20%'),
                DTColumnBuilder.newColumn('caseOwner').withTitle('Case Owner'),
                DTColumnBuilder.newColumn('caseCreatedTime').withTitle('CaseCreated_Time').notVisible(),
                DTColumnBuilder.newColumn('caseStatus').withTitle('Case Status'),
                DTColumnBuilder.newColumn('timeLog').withTitle('Time_Log').notVisible(),
                DTColumnBuilder.newColumn('timeLogCreatedTime').withTitle('TimeLogCreatedTime').notVisible(),
                DTColumnBuilder.newColumn('totalTimeHrs').withTitle('Total Time[Hrs]')
            ];
        }

        vm.query_by_caseId = function (caseId) {
            vm.caseId = caseId;
            $scope.caseId = vm.caseId;
            $scope.fileName = "NAS_RAC " + $scope.selectedYear.range + " Change Management Hours Report "
            $scope.fileName = $scope.fileName + vm.clliCode;
            $scope.fileName = $scope.fileName + " " + caseId;
            $scope.option = 'second';
            vm.customer = $scope.selectedCustomer.customerName
            var currentYear = $scope.selectedYear.reportYear;
            vm.caseIdFlag = true;
            ChangeManagementHoursReport.loadDataHoursReport({
                year: currentYear,
                option: 'second',
                customerName: vm.customer,
                caseId: $scope.caseId,
                clliCode: $scope.clliCode
            }).$promise;
            $scope.dtColumns = [
                DTColumnBuilder.newColumn('range').withTitle('Year').withOption('width', '10%'),
                DTColumnBuilder.newColumn('customer').withTitle('Customer').withOption('visible', $scope.isAdmin).withOption('width', '10%'),
                DTColumnBuilder.newColumn('clliCode').withTitle('Site Id'),
                DTColumnBuilder.newColumn('site').withTitle('Site Name'),
                DTColumnBuilder.newColumn('caseId').withTitle('Case Id'),
                DTColumnBuilder.newColumn('caseSummary').withTitle('Case Summary'),
                DTColumnBuilder.newColumn('caseOwner').withTitle('Case Owner'),
                DTColumnBuilder.newColumn('caseCreatedTime').withTitle('Case Created Time'),
                DTColumnBuilder.newColumn('caseStatus').withTitle('Case Status'),
                DTColumnBuilder.newColumn('timeLog').withTitle('Time Log'),
                DTColumnBuilder.newColumn('timeLogCreatedTime').withTitle('Time Log Created Time'),
                DTColumnBuilder.newColumn('totalTimeHrs').withTitle('Total Time[Hrs]')
            ];
        }
        vm.reload_state = function () {
            vm.reportsFlag = false;
            vm.caseIdFlag = false;
            $state.reload();
        };

        function getFileName() {
            return $scope.fileName;
        }

        function createdRow(row, data, dataIndex) {
            // Recompiling so we can bind Angular directive to the DT
            $compile(angular.element(row).contents())($scope);
        }

    }
})();

